import { FC, useState } from 'react';
import { useQuery } from '@apollo/client';
import { Center } from '@chakra-ui/react';

import ErrorCard from 'components/ErrorCard';
import Loader from 'components/Loader';
import * as Layout from 'layouts/ContentLayout';

import DeviceList from './components/DeviceList';
import DeviceSidebar from './components/DeviceSidebar';
import locales from './locales';
import { UserDevicesDocument } from './queries/deviceList.gql';
import { Device } from './types';

const RecentActivities: FC = () => {
  const { data, error, loading, refetch } = useQuery(UserDevicesDocument);
  const [selectedDevice, setSelectedDevice] = useState<Device | null>(null);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return (
      <Center h="100%">
        <ErrorCard retry={refetch} />
      </Center>
    );
  }

  const devices = data?.viewer.authenticationDevices || [];

  return (
    <Layout.Root>
      <Layout.Body>
        <Layout.Header
          description={locales.description}
          title={locales.title}
        />
        <DeviceList
          devices={devices}
          selectedDevice={selectedDevice}
          setSelectedDevice={setSelectedDevice}
        />
      </Layout.Body>

      {selectedDevice ? (
        <Layout.Sidebar
          borderLeft="1px solid"
          borderLeftColor="border"
          padding="space-16"
        >
          <DeviceSidebar
            device={selectedDevice}
            setSelectedDevice={setSelectedDevice}
          />
        </Layout.Sidebar>
      ) : null}
    </Layout.Root>
  );
};

export default RecentActivities;
